import { render, staticRenderFns } from "./CompanyReferral.vue?vue&type=template&id=4b820e3c&scoped=true&"
import script from "./CompanyReferral.vue?vue&type=script&lang=ts&"
export * from "./CompanyReferral.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyReferral.vue?vue&type=style&index=0&id=4b820e3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b820e3c",
  null
  
)

export default component.exports